import React from "react";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import AdminLogin from "./BaseFiles/AdminLogin";
import AdminDashboard from "./Admin/AdminDashboard";
import Logout from "./BaseFiles/Logout";
import PrivateRoute from "./BaseFiles/PrivateRoute";
import AdminMenu from "./Admin/AdminMenu";
import Products from "./Product/Products";
import AddProduct from "./Product/AddProduct";
import EditProduct from "./Product/EditProduct";
import Customer from "./Customer/Customer";
import SellHistory from "./History/SellHistory";
import PurchaseHistory from "./History/PurchaseHistory";
import CurrentPurchase from "./Billbook/CurrentPurchase";
import CurrentSale from "./Billbook/CurrentSale";


const App = () => {

  return (
    <Router>
      <div>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<AdminLogin />} />
          <Route path="/logout" element={<Logout isAdmin={false} />} />
          <Route path="/dashboard" element={<PrivateRoute component={<AdminMenu child={<AdminDashboard/>} />} isAdminRoute={true} />} />
          <Route path="/products" element={<PrivateRoute component={<AdminMenu child={<Products/>} />} isAdminRoute={true} />} />
          <Route path="/customers" element={<PrivateRoute component={<AdminMenu child={<Customer/>} />} isAdminRoute={true} />} />
          <Route path="/Sale/History" element={<PrivateRoute component={<AdminMenu child={<SellHistory/>} />} isAdminRoute={true} />} />
          <Route path="/Purchase/History" element={<PrivateRoute component={<AdminMenu child={<PurchaseHistory/>} />} isAdminRoute={true} />} />
          <Route path="/add/product" element={<PrivateRoute component={<AdminMenu child={<AddProduct/>} />} isAdminRoute={true} />} />
          <Route path="/Sale/Cart" element={<PrivateRoute component={<AdminMenu child={<CurrentSale/>} />} isAdminRoute={true} />} />
          <Route path="/Purchase/Cart" element={<PrivateRoute component={<AdminMenu child={<CurrentPurchase/>} />} isAdminRoute={true} />} />
          <Route path="/edit/product/:id" element={<PrivateRoute component={<AdminMenu child={<EditProduct/>} />} isAdminRoute={true} />} />
          
          
          <Route path="*" element={<h1>404 Not Found</h1>} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
